// DS-5361: the Zendesk messenger launcher renders above every app surface, so
// it paints over the DocuSign signing frame. Hide it while signing, restore it
// on the way out.
//
// This replaces a body CSS class that matched the launcher by id and class
// prefix (`div[class*="launcher"]` and friends). Those selectors track
// Zendesk's private DOM and break silently whenever it changes, and they only
// ever hid the launcher — an already-open conversation stayed on screen. The
// messenger API is the supported control, and it is what the dashboard MFE
// uses, so both now suppress the launcher the same way.
//
// No reference count here, unlike the dashboard's copy: this repo has exactly
// one consumer (the signing view) and no overlapping surfaces to race with.
// Guarded so an ad blocker, or a host that never loaded the snippet, no-ops
// instead of throwing.
export function setZendeskLauncherVisible(visible: boolean): void {
    if (typeof window === 'undefined') return;
    const zE = (window as unknown as { zE?: (...args: unknown[]) => void }).zE;
    if (typeof zE !== 'function') return;
    zE('messenger', visible ? 'show' : 'hide');
}
